import { z } from "zod";
import { timestampSchema } from "./timestamp";
import { choreKindSchema, choreScheduleSchema, choreSizeSchema } from "./chore";

export const proposalStatusSchema = z.enum([
  "pending",
  "approved",
  "rejected",
]);
export type ProposalStatus = z.infer<typeof proposalStatusSchema>;

export const choreProposalSchema = z.object({
  id: z.string(),
  title: z.string().min(1).max(80),
  description: z.string().max(500).optional(),
  icon: z.string().max(40).optional(),
  suggestedRewardMinor: z.number().int().min(0).max(1_000_000),
  // Sugerowana częstotliwość przez dziecko. Optional — backward-compat
  // dla starych propozycji bez schedule (parent dodaje dopiero przy approve).
  suggestedSchedule: choreScheduleSchema.optional(),
  // Sugerowany typ — family (pomoc rodzinie, XP, bez PLN) lub extra (z PLN).
  // Optional — backward-compat dla propozycji bez kind (parent ustawi przy approve).
  suggestedKind: choreKindSchema.optional(),
  // Sugerowana skala wysiłku (AI szacuje przy zatwierdzaniu propozycji).
  // Optional — propozycja od dziecka idzie bez size, AI estymuje przy approve.
  suggestedSize: choreSizeSchema.optional(),
  proposedBy: z.string(),
  proposedAt: timestampSchema,
  status: proposalStatusSchema,
  reviewedBy: z.string().optional(),
  reviewedAt: timestampSchema.optional(),
  rejectionReason: z.string().max(200).optional(),
  createdChoreId: z.string().optional(),
});
export type ChoreProposal = z.infer<typeof choreProposalSchema>;

export const choreProposalInputSchema = z.object({
  title: z.string().min(1).max(80),
  description: z.string().max(500).optional(),
  icon: z.string().max(40).optional(),
  suggestedRewardMinor: z.number().int().min(0).max(1_000_000),
  suggestedSchedule: choreScheduleSchema.optional(),
  suggestedKind: choreKindSchema.optional(),
  suggestedSize: choreSizeSchema.optional(),
});
export type ChoreProposalInput = z.infer<typeof choreProposalInputSchema>;
